"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.3979 2.414 19.1846 19.1907-1.3978 1.3965-2.0005-2.0011H11v-2h5.1848l-1.9994-2H7v-2h5.186l-1.9994-2H3V5.8113L1 3.8106l1.3979-1.3965zm5.7894 8.5861L5 7.8119V11h3.1873z"
  }), _react.default.createElement("path", {
    d: "m5.8117 3.0001 1.9994 2H11v3.19l2 2.0005V3.0001H5.8117zM15 12.1912l2 2.0007V7.0001h-2v5.1911zm4 4.0013 2 2.0006v-7.193h-2v5.1924z"
  })];
};

exports.default = _default;